<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1822_1391)">
      <path
        d="M13.2424 12.1942V12.1883H3.03609C2.19808 12.1883 1.51864 11.5112 1.51512 10.6732V1.04824C1.51512 0.630125 1.1757 0.29068 0.757559 0.29068C0.339418 0.29068 0 0.630098 0 1.04824V10.6732C0 12.3498 1.35948 13.7093 3.03609 13.7093H13.2425C13.6606 13.7093 14 13.3699 14 12.9518C14 12.5336 13.6606 12.1942 13.2424 12.1942Z"
        fill="#FFE400"
      />
      <path
        d="M12.3262 3.49119C11.9903 3.23985 11.5146 3.30796 11.2633 3.64388L9.50151 6.16904L7.01159 4.29572C6.67745 4.04438 6.20235 4.11132 5.95101 4.44549C5.95041 4.44666 5.94983 4.44724 5.94866 4.44841L3.78172 7.56081C3.52863 7.89378 3.59381 8.36945 3.92678 8.62257C4.0542 8.71948 4.20924 8.77348 4.36898 8.77644V8.79404C4.60094 8.78759 4.81764 8.67483 4.95624 8.48867L6.718 5.9635L9.20792 7.83682C9.54206 8.08817 10.0172 8.02123 10.2685 7.68706C10.2691 7.68588 10.2697 7.68531 10.2709 7.68413L12.4789 4.5541C12.7302 4.2182 12.6621 3.74253 12.3262 3.49119Z"
        fill="#FFE400"
      />
    </g>
    <defs>
      <clipPath id="clip0_1822_1391">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
